import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function addFeideTwoSchool(school, uuid) {
	return fetch(
		`${ENDPOINT_URL}/addfeidetwoschool`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				school,
				uuid,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			Promise.reject(apiErrorHandling(err));
			return err.ok;
		});
}
